import React from 'react';
import { ShiftProviderUser } from 'models';
import { Text } from 'library/ui';
import { TextContainer } from '../components/Containers';
import ThanksForFeedback from '../components/ThanksForFeedback';
import ProfileImage from '../components/ProfileImage';

const MainCopy = ({ provider, businessName }: { provider: ShiftProviderUser; businessName: string }) => (
    <>
        <ThanksForFeedback />
        <TextContainer>
            <Text align="center">Oh no! We are so sorry to hear you had a poor experience.</Text>
            <Text align="center">
                {`We use reviews as a way to ensure we are booking only the best workers for your center. If you'd like to take action now, you are also able to block ${provider.first_name} from your center for all future bookings.`}
            </Text>
        </TextContainer>
        <TextContainer>
            <Text weight="bold" align="center">
                Would you like to block {provider.first_name} from {businessName}?
            </Text>
        </TextContainer>
        <ProfileImage
            image={provider.profile_picture?.image}
            imageId={provider.id.toString()}
            initials={`${provider.first_name?.[0] ?? ''}${provider.last_name?.[0] ?? ''}`}
        />
    </>
);

export default MainCopy;
